/* SOBRE · "El regreso" — dos mecanismos y nada más.

   El reposo sin JS es la página COMPLETA y legible: el hilo aparece trazado
   entero, la lista de caminos se lee de arriba a abajo y el video del saludo
   muestra su póster. Nada de lo que hay aquí abajo agrega información — todo
   agrega TIEMPO, que es distinto. */
(function () {
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 · EL VIDEO DEL SALUDO ─────────────────────────────────────────────
     `preload="none"` y no arranca hasta que se ve: 918 KB no se descargan para
     alguien que no bajó de la primera pantalla. Y se PAUSA al salir — una
     pestaña con un video corriendo fuera de cuadro gasta batería a cambio de
     nada.
     🔴 `play()` devuelve una promesa que se resuelve DESPUÉS del evento; si el
     navegador la rechaza (política de autoplay, pestaña oculta) hay que
     atraparla o suelta un error no capturado en consola. */
  const cinta = document.querySelector('.saludo .cinta');
  if (cinta && !quieto) {
    const io = new IntersectionObserver(es => {
      for (const e of es) {
        if (e.isIntersecting) {
          if (cinta.preload === 'none') cinta.preload = 'auto';
          cinta.play().catch(() => {});
        } else if (!cinta.paused) {
          cinta.pause();
        }
      }
    }, { threshold: .35 });
    io.observe(cinta);
  }

  /* ── 2 · EL HILO QUE SE TRAZA ────────────────────────────────────────────
     `--trazo` va de 0 a 1 según cuánto del recorrido llevas andado. El largo
     real del path se mide UNA vez con `getTotalLength()` en lugar de adivinar
     un número: si mañana alguien cambia la curva, el trazo sigue cuadrando.
     Solo se escribe una custom property y solo se anima `stroke-dashoffset`:
     cero layout, cero pintura de más. */
  const hilo = document.querySelector('.cordel-hilo');
  const cordel = document.querySelector('.cordel');
  if (hilo && cordel && !quieto) {
    const path = hilo.querySelector('path');
    hilo.style.setProperty('--largo', path.getTotalLength().toFixed(1));
    hilo.style.setProperty('--trazo', '0');

    let pedido = false;
    const medir = () => {
      pedido = false;
      const r = cordel.getBoundingClientRect();
      const alto = innerHeight;
      /* Arranca cuando el recorrido entra por abajo y termina cuando su final
         cruza el centro de la pantalla: así el hilo va SIEMPRE un poco por
         delante del texto que estás leyendo, y nunca lo persigue. */
      const t = (alto * 0.86 - r.top) / (r.height + alto * 0.36);
      hilo.style.setProperty('--trazo', Math.max(0, Math.min(1, t)).toFixed(3));
    };
    addEventListener('scroll', () => {
      if (!pedido) { pedido = true; requestAnimationFrame(medir); }
    }, { passive: true });
    addEventListener('resize', medir, { passive: true });
    medir();
  }

  /* ── 3 · EL ÍNDICE CON FOCO — SE FUE CON LA SECCIÓN ─────────────────────
     Aquí vivían ~100 líneas que abrían una fila y recogían las otras cuatro, y
     movían UN <video> a la fila abierta. Se borraron junto con el marcado de
     §caminos v1, que paco mandó tirar («el drop down no le gustó a nadie»).

     No se dejó "por si acaso": el código estaba guardado tras `if (caja &&
     vias.length)`, así que en esta página ya no hacía nada, y cien líneas
     apagadas se leen como cien líneas vivas la próxima vez que alguien abra el
     archivo. El CSS de `.via*` SÍ se queda en `pagina.css` — lo siguen usando
     tres prototipos (`_s3.html`, `acordeon.html`, `camino-ab.html`) y borrarlo
     los rompería sin avisar. La sección nueva son `.cf-*` y no necesita JS:
     su revelado lo hace `revela.js` con el mecanismo que ya existía. */
})();

/* ── 4 · EL CREDO SE ENCIENDE PALABRA POR PALABRA ─────────────────────────
   El mecanismo ya existía en el sitio (la cita de la home) pero vivía atado a
   sus selectores. Aquí se aplica igual: apagada NO es invisible —a .18 el
   renglón sigue ocupando su sitio y se adivina—, así que la línea no salta
   cuando enciende. Sin JS la frase se lee entera y a plena opacidad. */
(function () {
  const f = document.querySelector('.credo-frase');
  if (!f || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  [...f.querySelectorAll('.cf-1,.cf-2')].forEach(tramo => {
    const frag = document.createDocumentFragment();
    tramo.childNodes.forEach(n => {
      if (n.nodeType === 3) {
        n.textContent.split(/(\s+)/).forEach(t => {
          if (!t.trim()) return frag.appendChild(document.createTextNode(' '));
          const w = document.createElement('span'); w.className = 'w'; w.textContent = t;
          frag.appendChild(w);
        });
      } else {
        n.classList.add('w'); frag.appendChild(n.cloneNode(true));
      }
    });
    tramo.replaceChildren(frag);
  });

  const ws = [...f.querySelectorAll('.w')];
  let pedido = false;
  const medir = () => {
    pedido = false;
    const r = f.getBoundingClientRect();
    /* Enciende conforme la frase cruza el tercio inferior: el barrido va al
       ritmo de la lectura, no al del scroll. */
    const p = (innerHeight * 0.82 - r.top) / (r.height + innerHeight * 0.24);
    const n = Math.round(Math.max(0, Math.min(1, p)) * ws.length);
    ws.forEach((w, i) => w.classList.toggle('on', i < n));
  };
  addEventListener('scroll', () => {
    if (!pedido) { pedido = true; requestAnimationFrame(medir); }
  }, { passive: true });
  addEventListener('resize', medir, { passive: true });
  medir();
})();
